export const RequisitionServiceTypeEnum = {
  Vacancy: {
    key: "7df49709-ed57-43c0-b172-41583f7def6e",
    value: 'vacancy',
  },
};
